import { variantProvider } from '@/app'
import { Icon, Text } from '@/components'
import { TypeGuards } from '@codeleap/types'
import { motion, AnimatePresence } from 'framer-motion'
import React, { CSSProperties, ReactElement, ComponentProps } from 'react'

type SuccessOverlayProps = {
  title?: string | ReactElement
  description: string | ReactElement
  icon: string
  visible: boolean
  style?: CSSProperties
  textStyle?: ComponentProps<typeof Text>['variants']
}

export const SuccessOverlay = (props: SuccessOverlayProps) => {
  const {
    title,
    description,
    icon,
    visible,
    style = {},
    textStyle = ['p1', 'regular', 'color:neutral2', 'textCenter'],
  } = props

  if (!visible) return null

  let iconVariants: string[]

  if (icon === 'send-primary3' || icon === 'swipe-down' || icon === 'empty-check') {
    iconVariants = ['iconSize:6']
  } else {
    iconVariants = ['iconSize:5', 'color:primary3']
  }

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        style={{ ...styles.wrapper, ...style }}
      >
        <motion.div
          initial={{ scale: 0.8 }}
          animate={{
            scale: [1, 1.1, 1],
            rotate: [0, 5, -5, 0],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        >
          <Icon name={icon} variants={iconVariants} debugName=''
          />
        </motion.div>

        {!!title ? (
          <Text variants={['h4', 'bold', 'color:neutral1']}>
            {TypeGuards.isString(title) ? <>{title}</> : title}
          </Text>
        ) : null}

        <Text variants={textStyle}>
          {TypeGuards.isString(description) ? <>{description}</> : description}
        </Text>
      </motion.div>
    </AnimatePresence>
  )
}

const styles = variantProvider.createComponentStyle(theme => ({
  wrapper: {
    display: 'flex',
    ...theme.presets.center,
    ...theme.presets.absolute,
    ...theme.presets.whole,
    ...theme.presets.column,
    ...theme.spacing.gap(1),
    backgroundColor: 'rgba(0, 0, 0, 0.60)',
    zIndex: 9999,
  }
}), true)